import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QUICKSTART_TRIGGERS_LIGHTS_ROUTES } from './../quickstart-lights/quickstart-lights.routes';
import { SelectTypeComponent } from './select-type/select-type.component';
import { QUICKSTART_TRIGGERS_KEYPADS_ROUTES } from '../quickstart-keypads/quickstart-keypads.routes';
import { QUICKSTART_TRIGGERS_REMOTES_ROUTES } from '../quickstart-system-remotes/quickstart-system-remotes.routes';

const SYSTEM_REMOTES_QUERY: any = {
  $and: [{
    proxy: { $in: ['user_interface'] }
  }, {
    type: 7
  }]
};

export const QUICKSTART_TRIGGERS_BUTTONS_ROUTES: Routes = [{
  path: 'buttons', children: [
    ...QUICKSTART_TRIGGERS_LIGHTS_ROUTES,
    ...QUICKSTART_TRIGGERS_KEYPADS_ROUTES,
    ...QUICKSTART_TRIGGERS_REMOTES_ROUTES,
  ]
}];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-buttons/buttons.routes.ts